import React from 'react';

function withSkeleton(Component, SkeletonComponent) {
  return function (props) {
    if (props.loading) return <SkeletonComponent {...props} />;
    return <Component {...props} />;
  };
}

export default withSkeleton;
